<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link v-if="this.gstock" :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ $t("integraciones") }}
            </li>
          </ol>
        </nav>
      </div>

      <!-- Cabecera para elegir el negocio y actualizar el "idBusiness".
      Mandamos el idBusiness como parámetro a BusinessCentral.vue -->
      <div class="col-md-12" v-if="businessCentral">
        <div class="card">
          <div class="row">
            <div class="col-md-4" v-if="!sectores">
              <div class="form-group">

                <!-- <label for="listBusiness">{{ $t("negocio") }}</label>

                          <el-select class="select-default" size="large" v-model="idBusiness" filterable
                              :placeholder="$t('seleccionaNegocio')" @change="cambioNegocio()">
                              <el-option v-for="business in listBusinesses" class="select-primary"
                                  :value="business.id" :label="business.establishmentName"
                                  :key="business.establishmentName">
                              </el-option>
                          </el-select> -->

                <label>{{ $t("companya") }}</label>
                <el-select class="select-default" size="large" v-model="idCompany" filterable
                  :placeholder="$t('seleccionaCompania')" @change="cambioCompany()">
                  <el-option v-for="c in listCompany" class="select-primary" :value="c.id" :label="c.name"
                    :key="c.name">
                  </el-option>
                </el-select>

              </div>
            </div>
            <!--
                  <div :class="idSector == 0 || verBusinesses == true ? 'col-md-2' : 'col-md-4'" v-else>
                      <div class="form-group">
                          <label for="listSectores">Sector</label>

                          <el-select class="select-default" size="large" v-model="idSector" filterable
                              @change="cambioSector()" :placeholder="'Seleccionar un sector'">
                              <el-option v-for="sector in listaSectores" class="select-primary" :value="sector.id"
                                  :label="sector.name" :key="sector.name">
                              </el-option>
                          </el-select>
                      </div>
                  </div>
                  <div class="col-md-2" v-if="this.idSector == 0 && this.sectores">
                      <div class="form-group">
                          <label for="listSectores">{{ $t("negocio") }}</label>

                          <el-select class="select-default" size="large" v-model="idBusiness" filterable
                              @change="cambioNegocio()" :placeholder="$t('seleccionaNegocio')">
                              <el-option v-for="negocio in listaNegociosSinSector" class="select-primary"
                                  :value="negocio.id" :label="negocio.establishmentName"
                                  :key="negocio.establishmentName">
                              </el-option>
                          </el-select>
                      </div>
                  </div>
                  <div class="col-md-2" v-if="verBusinesses">
                      <div class="form-group">
                          <label for="listSectores">{{ $t("negocio") }}</label>
                          <el-select
                            class="select-default"
                            size="large"
                            v-model="idBusiness"
                            filterable
                            @change="cambioNegocio()"
                            :placeholder="$t('seleccionaNegocio')"
                            >
                              <el-option v-for="negocio in listBusinesses"
                                class="select-primary"
                                :value="negocio.id"
                                :label="negocio.establishmentName"
                                :key="negocio.establishmentName">
                              </el-option>
                          </el-select>
                      </div>
                  </div>-->
          </div>
        </div>
      </div>
      <!-- HASTA AQUÍ LA CABECERA -->

      <div class="col-md-4">
        <h2><i class="fas fa-warehouse"></i> {{ $t("almacen") }}</h2>
        <card>
          <div class="content-card">
            <ul class="list-files">
              <router-link v-if="this.gstock" :to="{ name: 'gstock', params: { pag: 1 } }">
                <li>
                  {{ $t('GStock') }}
                  <br />
                  <span class="text-muted">{{ $t('herramientaControlStockControlComprasInventarios') }}</span>
                </li>
              </router-link>
              <router-link v-if="this.gstock" :to="{ name: 'productosnorelacionados', params: { pag: 1 } }">
                <li>{{ $t('productosNoRelacionados') }}<br />
                  <span class="text-muted">{{ $t('productosNoRelacionadosDescripcion') }}</span>
                </li>
              </router-link>
              <!-- <router-link
                  v-if="this.gstock"
                :to="{ name: 'diagnostico-PLU' , params: { pag: 1 } }"
              >
                <li>{{ $t('diagnosticoPLU') }}<br />
                  <span class="text-muted">{{ $t('diagnosticoPLU') }}</span>
                </li>
              </router-link> -->
            </ul>
          </div>
        </card>
      </div>
      <div class="col-md-4">
        <h2><i class="fas fa-warehouse"></i> {{ $t("fidelizacion") }}</h2>
        <card>
          <div class="content-card">
            <ul class="list-files">
              <router-link v-if="this.cheerfy" :to="{ name: 'cheerfy' }">
                <li>
                  {{ $t('cheerfy') }}
                  <br />
                  <span class="text-muted">{{ $t('plataformaGestionPromocionesClientes') }}</span>
                </li>
              </router-link>
            </ul>
          </div>
        </card>
      </div>

      <div class="col-md-4" v-if="businessCentral">
        <h2><i class="fas fa-chalkboard-teacher"></i> {{ $t("general") }}</h2>
        <card>
          <div class="content-card">
            <ul class="list-files">
              <router-link :to="{ name: 'businesscentral', params: { listBusinesses: this.listBusinesses } }">
                <li>
                  {{ $t('businessCentral') }}
                  <br />
                  <span class="text-muted">{{ $t('sincronizacionBusinessCentralSubtitle') }}</span>
                </li>
              </router-link>
            </ul>
          </div>
        </card>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { Select, Option, Dropdown, DropdownItem, DropdownMenu } from 'element-ui'
import bus from '../../../bus'
import { mapState } from 'vuex';
import { Loading } from 'element-ui';
export default {
  created() {
    this.$store.dispatch("setNameRoute", "Integraciones");

    //this.getBusiness();
    this.loadingGeneral = Loading.service({ text: this.$t('cargando') });
    this.getCompanies();

    bus.$on('get-business', (idBusiness) => {
      this.idBusiness = idBusiness;
      this.idsTPV = [];
      this.idTpv = 0;
    });

    this.getTpvsRetail();
    this.tieneGStock();
    this.tieneCheerfy();
    this.tieneBusinessCentral();
  },

  components: {
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Option.name]: Option,
  },
  data() {
    return {
      soloRetail: true,
      idBusiness: this.$store.getters.idBusiness,
      // ListidBusiness:[],
      //  ListidTpvs:[],
      gstock: true,
      cheerfy: true,
      businessCentral: false,
      idTpv: 0,

      // BUSINESS CENTRAL
      listBusinesses: [],
      business: null,

      idCompany: null,
      listCompany: [],
      mostrarNotificacionRedirect: true
    };
  },

  computed: {
    ...mapState(["listaSectores", "sectores"]),
  },

  methods: {
    // getBusiness() {
    //   var config = {
    //     params: {
    //       jwt: this.$store.getters.jwt,
    //     },
    //     headers: { Authorization: "Bearer " + this.$store.getters.jwt },
    //   };

    //   let vm = this;
    //   this.axios
    //     .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
    //     .then(function(response) {


    //       response.data.result.forEach(element => {
    //         vm.ListidBusiness.push(element.id)
    //       });

    //       vm.getTpv();

    //     })
    //     .catch(function(error) {
    //       console.log(error);
    //     });
    // },
    // getTpv() {

    //     var config = {
    //         params: {
    //             idBusiness: this.ListidBusiness,
    //             jwt: this.$store.getters.jwt
    //         },
    //         headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
    //     };

    //     let vm = this;
    //     this.axios.get(this.$store.getters.apiUrl + "general/getTpvsByListBusiness", config)
    //       .then(function (response) {

    //         if (response.data.response) {

    //           vm.ListidTpvs=response.data.result;
    //           //console.log(vm.ListidTpvs);
    //           //vm.tieneGStock();
    //         }
    //     })
    //     .catch(function (error) {
    //         console.log(error);
    //     });
    //  // vm.tieneGStock();
    // },

    getTpvsRetail() {
      var config = {
        params: {
          idTpv: this.idTpv,
          jwt: this.$store.getters.jwt
        },
        headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
      };
      let vm = this;
      this.axios.get(this.$store.getters.apiUrl + "tpvs/getTpvsRetail", config)
        .then(function (response) {
          if (response.data.result) {
            vm.soloRetail = false;
          } else {
            vm.soloRetail = true;

          }
        })
    },

    tieneGStock() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "general/getRestrictionsByUser",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            for (let i = 0; i < response.data.result.length; i++) {

              switch (response.data.result[i].idRestriction) {
                case "72":
                  vm.gstock = true;
                  break;
              }
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    tieneCheerfy() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "general/getRestrictionsByUser",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            for (let i = 0; i < response.data.result.length; i++) {

              switch (response.data.result[i].idRestriction) {
                case "75":
                  vm.cheerfy = true;
                  break;
              }
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    tieneBusinessCentral() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "general/getRestrictionsByUser",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            for (let i = 0; i < response.data.result.length; i++) {

              switch (response.data.result[i].idRestriction) {
                case "76":
                  vm.businessCentral = true;
                  break;
              }
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    cambioCompany() {
      this.mostrarNotificacionRedirect = false;
      this.getBusinessListByCompany();
      this.loadingGeneral = Loading.service({ text: this.$t('cargando') });
    },

    getCompanies() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt
        },
        headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
      };

      let vm = this;
      this.axios.get(this.$store.getters.apiUrl + "general/getCompaniesByUser", config)
        .then(function (response) {

          if (!vm.idCompany) {
            vm.idCompany = response.data.result[0].id;
            //console.log(" > La Company seleccionada es:", vm.idCompany,);
          }
          vm.listCompany = response.data.result;

          // console.log(" > Lista de Companies actualizada:", vm.listCompany,);
          vm.getBusinessListByCompany()

        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getBusinessListByCompany() {
      var config = {
        params: {
          idCompany: this.idCompany,
          jwt: this.$store.getters.jwt
        },
        headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
      };
      let vm = this;
      this.axios.get(this.$store.getters.apiUrl + "businesses/getBusinessesByIdCompany", config)
        .then(function (response) {

          vm.listBusinesses = response.data;
          // console.log("> La listBusinesses by Company es:", vm.listBusinesses,);
          vm.loadingGeneral.close();

          // Si vengo de un redirect, le notifico al usuario por qué ha sido redirigido a Integraciones.
          if (vm.mostrarNotificacionRedirect) {
            // vm.checkRedirect();
          }

        })
        .catch(function (error) {
          console.log(error);
        });
    },

    checkRedirect() {
      //console.log(" > Hacemos el checkredirect.", this.$route.params);

      if (this.$route.params.redirected) {
        // console.warn("Has sido redirigido porque faltaban datos necesarios.");
        this.$notify({
          message: this.$t("redirigidoIntegracionesBC"),
          icon: "nc-icon nc-check-2",
          timeout: 8000,
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "success",
        });

        // Limpiar params (esto es necesario porque params NO se pueden modificar en la URL directamente)
        // this.$router.replace({ name: "integraciones", params: {} });

        // Solo hacemos replace si no estamos ya en la ruta "integraciones"
        if (this.$route.name !== "integraciones") {
          this.$router.replace({ name: "integraciones", params: {} }).catch(() => { });
        } else {
          // Limpiar params sin navegar si ya estamos en la ruta
          this.$router.replace({ name: "integraciones", params: {} }).catch(() => { });
        }
      }
    },
  },
};
</script>

<style scoped>
h3 {
  margin: 10px 0;
  color: #1E22AA;
  font-family: "Roboto", "Helvetica Neue", Arial, sans-serif;
}

h2 {
  margin: 10px 5px;
  font-family: "Numier", "Helvetica Neue", Arial;
  font-weight: bold;
  color: #1E22AA;
  font-size: 25px;
}

i {
  font-size: 20px;
}

.list-files {
  padding: 0;
  margin-bottom: 0px;
}

.list-files a:first-child li {
  border-top: none;
}

.list-files a li {
  list-style: none;
  padding: 15px 20px;
  font-size: 1.1em;
  border-top: 1px solid #bbb;
  /*font-weight: bold;*/
  color: #252422;
}

.list-files a li span {
  font-size: 0.7em;
}

.list-files p {
  margin: 0;
}

.list-files a li:hover {
  cursor: pointer;
  background-color: rgba(0, 153, 130, 0.2);
}

.content-card {
  border-top: 2px solid #00A3AD;
  padding: 0;
}

.prox {
  font-weight: 400;
  font-size: 0.8em;
}

.card {
  padding: 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Integraciones/Integraciones.vue